/* unplugin-vue-components disabled */import script from "./StudentAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./StudentAnalysis.vue?vue&type=style&index=0&id=73d862fc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d862fc"]])

export default __exports__